module.exports = __webpack_public_path__ + "img/welfare-blackfriday.961b2547.png";